module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/deco_gray01-1bb32090d9f03bf063606f105aaee9fe.png";